import { render } from "./natziv.vue?vue&type=template&id=74dc0c66&scoped=true"
import script from "./natziv.vue?vue&type=script&lang=js"
export * from "./natziv.vue?vue&type=script&lang=js"

import "./natziv.vue?vue&type=style&index=0&id=74dc0c66&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dc0c66"]])

export default __exports__